import { Injectable } from '@angular/core';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';

import { ConfirmDialogComponent } from 'app/shared/components/confirm-dialog/confirm-dialog.component';


@Injectable({
  providedIn: 'root'
})
export class DialogHelperService {

  bsModalRef: BsModalRef;

  constructor(private modalService: BsModalService) { }

  showPrompt(title: string, message: string, buttonText: string, confirm: Function) {
    this.showDialog(title, message, buttonText, confirm, null, true);
  }

  showConfirm(title: string, message: string, buttonText: string, confirm: Function, cancel?: Function) {
    this.showDialog(title, message, buttonText, confirm, cancel);
  }

  private showDialog(
    title: string,
    message: string,
    buttonText: string,
    confirm: Function,
    cancel?: Function,
    hideCancel?: boolean
  ) {
    this.bsModalRef = this.modalService.show(ConfirmDialogComponent, {
      class: 'modal-lg',
      backdrop: 'static'
    });

    this.bsModalRef.content.title = title;
    this.bsModalRef.content.message = message;
    this.bsModalRef.content.buttonText = buttonText;
    this.bsModalRef.content.submit = () => confirm ? confirm() : this.bsModalRef.hide();
    this.bsModalRef.content.hideCancel = hideCancel;
    if (!!cancel) {
      this.bsModalRef.content.cancel = () => cancel();
    }
  }
}


